import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { MdSpaceDashboard, MdVpnKey } from 'react-icons/md';
import { RiDashboard3Line } from 'react-icons/ri';

export const AdminNavigation = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="bg-surface-base rounded-xl shadow-lg overflow-hidden mb-2">
      <div className="flex bg-gradient-to-r from-[#0882a0] to-[#6D5FC0] rounded-xl">
        <Link
          to="/admin"
          className={`flex-1 py-3 px-4 text-sm font-medium transition-colors ${
            isActive('/admin')
              ? 'text-white border-b-2 border-blue-500'
              : 'text-gray-300 hover:text-white'
          }`}
        >
          <MdSpaceDashboard
            size={20}
            className="mr-2 inline-block"
          />
          {t('header.dashboard')}
        </Link>
        <Link
          to="/admin/metrics"
          className={`flex-1 py-3 px-4 text-sm font-medium transition-colors ${
            isActive('/admin/metrics')
              ? 'text-white border-b-2 border-white'
              : 'text-gray-300 hover:text-white'
          }`}
        >
          <RiDashboard3Line
            size={20}
            className="mr-2 inline-block"
          />
          {t('header.metrics')}
        </Link>
        <Link
          to="/admin/license-activity"
          className={`flex-1 py-3 px-4 text-sm font-medium transition-colors ${
            isActive('/admin/license-activity')
              ? 'text-white border-b-2 border-white'
              : 'text-gray-300 hover:text-white'
          }`}
        >
          <MdVpnKey
            size={20}
            className="mr-2 inline-block"
          />
          {t('admin.nav.licenseActivity')}
        </Link>
        {/* Future links can be added here:
        <Link
          to="/admin/users"
          className={`flex-1 py-3 px-4 text-sm font-medium transition-colors ${
            isActive('/admin/users')
              ? 'text-surface-base border-b-2 border-surface-base'
              : 'text-gray-300 hover:text-white'
          }`}
        >
          <FaUsers size={20} className="mr-2 inline-block" />
          Users
        </Link>
        */}
      </div>
    </div>
  );
};
